// extracted by mini-css-extract-plugin
module.exports = {"Security":"style_Security__74fTC","Tittle":"style_Tittle__WUGeS","DisconectInfo":"style_DisconectInfo__S42t9","DisconectBtn":"style_DisconectBtn__c7Lmt"};